export const NotificationsStatuses = {
  UNREAD:'UNREAD',
  READ:'READ',
  UNREAD_HOVER:'UNREAD_HOVER',
  READ_HOVER:'READ_HOVER'
};
